import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import { doLogout } from "../store/slices/authSlice";
import { readToken } from "../services/localStorage.Service";

interface Props {
  roles: Array<"admin" | "controleur" | "visiteur">;
}

const PrivateRoute: React.FC<Props> = ({ roles }) => {
  const dispatch: AppDispatch = useDispatch();
  const { isAuthenticated, user } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = readToken();

      if (token) {
        try {
          // Decode token manually to get the expiration
          const base64Url = token.split(".")[1];
          const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          const decodedPayload = JSON.parse(window.atob(base64));

          const exp = decodedPayload.exp * 1000; // Convert expiration time to milliseconds
          const isTokenExpired = exp < Date.now();
          console.log(isTokenExpired);

          if (isTokenExpired) {
            dispatch(doLogout());
          }
        } catch (error) {
          console.error("Failed to decode token:", error);
          dispatch(doLogout()); // Log out if decoding fails
        }
      } else {
        dispatch(doLogout()); // Log out if there's no token in localStorage
      }
    };

    checkTokenExpiration();

    const interval = setInterval(checkTokenExpiration, 600000); // Check every hour
    return () => clearInterval(interval);
  }, [dispatch]);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
